import type { AtualizarCargoDto, CargoResponse, CriarCargoDto, ListarCargosQuery } from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

/** Cargos da empresa (GET /cargos): `rh.ver`. Sem a permissao a API responde 403. */
export function useCargos(q: Partial<ListarCargosQuery> = {}) {
  return useConsulta<CargoResponse[]>(['cargos'], '/cargos', { query: q });
}

export function useCriarCargo() {
  return useMutacao<CargoResponse, CriarCargoDto>({
    metodo: 'POST',
    caminho: () => '/cargos',
    corpo: (v) => v,
    invalidar: [['cargos'], ['pessoas']],
  });
}

export function useAtualizarCargo() {
  return useMutacao<CargoResponse, { id: string } & AtualizarCargoDto>({
    metodo: 'PATCH',
    caminho: (v) => `/cargos/${v.id}`,
    corpo: ({ id: _id, ...resto }) => resto,
    invalidar: [['cargos'], ['pessoas']],
  });
}
